import { useRequest } from "hooks/useRequest";
import { FirmwareBundle } from "utils/firmware-bundles";

export default function useFirmwareBundles() {
  const { data, error, isLoading, mutate } = useRequest("appSystemInfo?swVersion=bundles");
  return { bundles: (Array.isArray(data) ? data : []) as FirmwareBundle[], error, isLoading, mutate };
}
